import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { registerUser } from "../../../react-cognito";
import { NotificationManager } from "react-notifications";
import store from "../../../store";
import { Loader } from "../../../components/loader";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import Steps, { Step } from "rc-steps";
import PetInfo from "../../../components/petInfo/petInfo";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import DatePicker from "react-datepicker";
import moment from "moment";
import Select from "react-select";
import AddHwFindUs from "./addHwFindUs";
import "react-select/dist/react-select.css";
import { NavLink } from "react-router-dom";

import { fetchMedicalRecords } from "../../../actions/medicalRecords";
import { addContract, updatePrintContract, getRecentAvailableMedicalRecords } from "../../../actions/contracts";
import { getNotificationsByMedicalRecord } from "../../../actions/subscribeToPet";
import { fetchHwFindUs, addHwFindUs } from "../../../actions/howFindUs";
import { BreadCrumb } from "../../../components/breadcrumb";
import { stopBackgroundScroll } from "../../../actions/sideBar";
import petInfo from "../../../components/petInfo/petInfo";
import ContractPDF from "../../../components/contractPdf/contractPdf.js";
import { fetchConfig } from "../../../actions/configuration.js";
import { fetchPaymentType } from "../../../actions/paymentType.js";
import { forceInputUppercase } from "../../../utils/helper";

const { SearchBar } = Search;
const $ = window.$;
const initialState = {
  petIdInput: "",
  country: "",
  currentStep: 0,
  currentStepNotValid: false,
  petId: "",
  petInfo: "",
  pets: [],
  date: moment().toDate(),
  firstname: "",
  lastname: "",
  address: "",
  address_opt: "",
  city: "",
  state: "",
  zip_code: "",
  phone_primary: "",
  phone_primary_type: "mobile",
  phone_secondary: "",
  phone_secondary_type: "mobile",
  email: "",
  hwTypes: [],
  hwFindUS: "",
  price: 0,
  taxRate: 0,
  tax: 0,
  discount : 0,
  newDiscount : 0,
  discountApplied : false,
  total: 0,
  payment_types: [],
  payments: [
    // { method: "credit_debit", card_type: "", amount: 0, last_digits: "" },
    { method: "other", amount: 0 }
  ],

  delivery_address: "",
  delivery_address_opt: "",
  delivery_town_city: "",
  delivery_state: "",
  delivery_zip_code: "",

  sameAsBillingAddress: true,

  loading: false,
  loadingStore: false,
  contractSubmitData: {},
  searchedMedicalRecords :[],
  selectedMedicalRecord:{},
  loadingInfo: false,
  soldReason: null,
  selectedWooPageStatusOption : null,
  selectedWooPagePuppyStatusOption : null,
  isPetAvailableInStore : false,
  loadingWooPageStatus : false,
  availableSubscribers : [],
  isFindUsOtherEnable : false,
};
let contractAttr = {};
let form_step_0 = {};
let form_step_1 = {};
let form_step_2 = { payments: [{ amount: 0 }] };
const soldReasonValues = [
  {
    id : 1,
    key: "sold-by-the-breeder",
    value: "Sold by the Breeder",
    notify: true
  },
  {
    id: 2,
    key: "on-medical-treatment",
    value: "On Medical Treatment",
    notify: false
  },
  {
    id: 3,
    key: "financing",
    value: "Financing",
    notify: false
  },
  {
    id : 4,
    key: "on-hold",
    value: "On Hold",
    notify: false
  }
];
const HOW_YOU_FIND_US ={
  OTHER : "Other"
};
const NOT_AVAILABLE = "N/A";
class Datamodal extends React.Component {
  constructor(props) {
    super(props);
  }
  state = initialState;

  tableHecaderColumnData = [
    {
      dataField: "pet_id",
      text: "Pet ID",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span className="m-topbar__userpic">
            <img
              src={
                process.env.REACT_APP_S3_PATH +
                "/" +
                row.avatar_path +
                "/" +
                row.avatar_file_name
              }
              className="m--img-rounded m-width-50 mr-2"
              alt=""
            />
            <span className="m-badge m-badge--info mx-auto my-0 px-2">
              <strong>{cell}</strong>
            </span>
          </span>
        );
      }
    },
    {
      dataField: "breed_type",
      text: "Breed",
      sort: true
    },
    {
      dataField: "sex",
      text: "Gender",
      sort: true,
      formatter: cell => cell
    },
    {
      dataField: "price",
      text: "Price",
      sort: true,   

    },     
  ];

  wooPageStatusOptions = {
    Public: "public",
    Finance: "finance",
    Private: "private"
  }

  wooPagePuppyStatusOptions = {
    Sold: "sold",
    Available: "available"
  }
  
  rowEvents = {
    onClick: (e, row, rowIndex) => { 
     if(row){     
        this.setState( {selectedMedicalRecord : row, selectedWooPageStatusOption: row.woo_page_status,
        selectedWooPagePuppyStatusOption: row.woo_pet_availability, isPetAvailableInStore : row.woo_pet ? true : false } );
        this.props.getNotificationsByMedicalRecord(row.id);
        $("#confirm_select_modal").modal("show"); 
      }
    }
  }

  submitContract = data => {
    this.setState({ loading: true });
    this.props.createContract(data);
  };
  validateStep = event => {
    if(this.state.petId.toString().trim().length > 0 && this.state.petInfo.Contract) {
      NotificationManager.error("This pet is already sold.");
    } else if(this.state.petId.toString().trim().length > 0 && this.state.petInfo.mc_status === 'draft') {
      NotificationManager.error("This pet is in draft.");
    }
    switch (this.state.currentStep) {
      case 0:
        form_step_0 = {
          petId:
            this.state.petId.toString().trim().length > 0 && this.state.petInfo.mc_status === 'complete' && !this.state.petInfo.Contract
              ? this.state.petId
              : null
        };
        this.checkValues(form_step_0);
        break;
      case 1:
        const regX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        form_step_1 = {
          date: moment(this.state.date).isValid()
            ? moment(this.state.date).format("YYYY-MM-DD")
            : null,
          firstname:
            this.state.firstname.trim().length > 0
              ? this.state.firstname
              : null,
          lastname:
            this.state.lastname.trim().length > 0 ? this.state.lastname : null,
          saddress:
            this.state.address.trim().length > 0 ? this.state.address : null,
          saddress_opt:
            this.state.address_opt.trim().length > 0
              ? this.state.address_opt
              : "N/A",
          city: this.state.city.trim().length > 0 ? this.state.city : null,
          state: this.state.state.trim().length > 0 ? this.state.state : null,
          zip:
            this.state.zip_code.toString().trim().length > 0
              ? this.state.zip_code
              : null,
          phone_primary:
            this.state.phone_primary.toString().trim().length > 0
              ? this.state.phone_primary
              : null,
          phone_primary_type: this.state.phone_primary_type,
          phone_secondary: this.state.phone_secondary &&
            this.state.phone_secondary.toString().trim().length > 0
              ? this.state.phone_secondary
              : '',
          phone_secondary_type: this.state.phone_secondary_type,
          email: String(this.state.email)
            .toLowerCase()
            .match(regX)
            ? this.state.email
            : null,
          delivery_address: this.state.delivery_address.trim().length > 0 ? this.state.delivery_address : "",
          delivery_address_opt: this.state.delivery_address_opt.trim().length > 0 ? this.state.delivery_address_opt : "",
          delivery_town_city: this.state.delivery_town_city.trim().length > 0 ? this.state.delivery_town_city : "",
          delivery_state: this.state.delivery_state.trim().length > 0 ? this.state.delivery_state : "",
          delivery_zip_code: this.state.delivery_zip_code.trim().length > 0 ? this.state.delivery_zip_code : "",
        };
        if( this.state.isFindUsOtherEnable ){
          if(this.state.find_us_other && this.state.find_us_other.toString().trim().length > 0){
            form_step_1.hfindus = this.state.find_us_other;
            form_step_1.isInValidFindUsOther = false;
            form_step_1.isInValidHFindus = false;
          }else{
            form_step_1.hfindus = null;
            form_step_1.isInValidHFindus = false;
            form_step_1.isInValidFindUsOther = true;
          }
        }else {
          form_step_1.hfindus = this.state.hwFindUS === NOT_AVAILABLE ? null : this.state.hwFindUS;   
          form_step_1.isInValidHFindus =  this.state.hwFindUS === NOT_AVAILABLE ? true : false;   
        }
        this.checkValues(form_step_1);
        break;
      case 2:
        var paymentArray = this.state.payments.map(a => ({ ...a }));
        form_step_2 = {
          price: this.state.price > 0 ? this.state.price : null,
          tax: this.state.tax >= 0 ? this.state.tax : null,
          total: this.state.total,
          discount : this.state.discount,     
          payments: this.confirmPayments(paymentArray)
        };
        this.checkValues(form_step_2);
        break;
    }
  };
  removePayment = (event, id) => {
    event.preventDefault();
    let newPayments = Object.assign({}, this.state.payments.splice(id, 1));
    this.setState({ newPayments });
    form_step_2.payments.splice(id, 1);
  };

  checkValues = step_form => {
    let data = Object.values(step_form).map(key => {
      if (key !== null) {
        if (Array.isArray(key)) {
          var found = false;
          for (var i = 0; i < key.length; i++) {
            if (key[i].method === "other" && key[i].other_type === null) {
              found = true;
              break;
            }
            if (
              key[i].method === "credit_debit" &&
              key[i].last_digits === null
            ) {
              found = true;
              break;
            }
            if (key[i].method === "credit_debit" && key[i].card_type === null) {
              found = true;
              break;
            }
            if (key[i].amount === null) {
              found = true;
              break;
            }
          }
          if (found === true) {
            return false;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    });
    // if (!data.includes(false)) {
    if (!data.includes(false)) {
      contractAttr = Object.assign(contractAttr, step_form);
      if (this.state.currentStep === 2) {
        this.setState({contractSubmitData: contractAttr});
        if(this.state.isPetAvailableInStore){       
          this.setState( { selectedWooPagePuppyStatusOption : this.wooPagePuppyStatusOptions.Sold });
          $("#woo_page_status_modal").modal("show");
        }else{     
          let data = contractAttr;
          data["notifySubscribers"] = false;
          this.submitContract(data);
        }    
      } else {
        this.nextStep();
      }
    } else {
      NotificationManager.warning("Please check input details again.");
      this.setState({ currentStepNotValid: true });
      //this.nextStep();
    }
  };
  confirmPayments = payments => {
    return payments.map(item => {
      if (!item.amount > 0) {
        item.amount = null;
      }
      if (!item.last_digits) {
        item.last_digits = null;
      }
      if (!item.other_type) {
        item.other_type = null;
      }
      if (!item.card_type) {
        item.card_type = null;
      }
      return item;
    });
  };
  nextStep = () => {
    this.setState({
      currentStep: this.state.currentStep + 1,
      currentStepNotValid: false
    });
  };

  changePayment = (event, index) => {
    let value = event.target.value.toString();
    if (index >= 0) {
      if (event.target.name === "last_digits") {
        if (value.length <= 4) {
          if (!value.match("^[0-9]{4}$")) {
            value = undefined;
          }
          if (value === "0000") {
            value = undefined;
          }
        } else {
          return true;
        }
      }
      // if (event.target.name === "other_type" && event.target.value === null) {
      //   value = undefined;
      // }
      this.setState({
        payments: [
          ...this.state.payments.slice(0, index),
          Object.assign({}, this.state.payments[index], {
            [event.target.name]: value
          }),
          ...this.state.payments.slice(index + 1)
        ]
      });
    }
  };
  changeVal = event => {
    let excludes = [
      "email",
      "phone_primary_type",
      "phone_secondary_type",
      "price"
    ];
    if (!excludes.includes(event.target.name)) forceInputUppercase(event);
    const value = event.target.value;
    this.setState({
      ...this.state,
      [event.target.name]: value
    });

    if(event.target.name === 'price' && value > 0) {
      if(this.state.payments.length === 1) {
        this.setState({
          payments: [
            ...this.state.payments.slice(0, 0),
            Object.assign({}, this.state.payments[0], {
              amount: value
            })
          ]
        });
      }
    }
  };

  calculateTotal = (price, taxRate, discount) => {
    let sub_total = parseFloat(price) - discount;
    let new_tax = (sub_total * parseFloat(taxRate)) / 100;
    let total = sub_total + new_tax;
    return {total : parseFloat(total).toFixed(2) , tax : parseFloat(new_tax).toFixed(2)};
  }

  newPayment = event => {
    event.preventDefault();
    form_step_2.payments.push({
      method: "other",
      amount: 0
    });
    var total_payments = 0
    for(let i of this.state.payments) {
      total_payments = parseFloat(total_payments) + parseFloat(i.amount);
    }
    var pay_value = 0;

    if(this.state.price > 0 && total_payments < this.state.price) {
      pay_value = parseFloat(this.state.price) - parseFloat(total_payments);
    }
    var joined = this.state.payments.concat({
      method: "other",
      amount: pay_value
    });
    this.setState({ payments: joined });
  };
  changeHwType = selected => {
  this.setState({ hwFindUS: selected.value });  
    if(selected.value == HOW_YOU_FIND_US.OTHER){
      this.setState({ isFindUsOtherEnable : true });
    }else{
      this.setState({ isFindUsOtherEnable : false });    
    }
  };
  // changePet = (selected) => {
  //     this.setState({ petId: selected.value });
  //     this.validateStep();
  // }

  findPet = event => {
    this.setState({ petIdInput: event.target.value });
    const selected = this.state.pets.find(e => {
      return e.label === event.target.value;
    }); 
    if (selected) {
      this.setState({ petId: selected.value });
      this.handleInputChange = this.handleInputChange.bind(this);
      this.setState( { selectedWooPageStatusOption: selected.wooPageStatus,selectedMedicalRecord : selected,
        selectedWooPagePuppyStatusOption: selected.wooPetStatus, isPetAvailableInStore : selected.wooPet ? true : false } );
      // this.validateStep();
    } else {
      this.setState({ petId: "" });
    }
    //this.validateStep();
  };

  setMedicalRecord = () => {
    this.setState({ petIdInput: this.state.selectedMedicalRecord.pet_id,  petId: this.state.selectedMedicalRecord.id });
    $("#confirm_select_modal").modal("hide");
    $("#recent-medical-record-modal").modal("hide");
  }

  changeDate = value => {
    this.setState({ date: value });
  };

  handleChange = (e) => {
    if(e && e.target && e.target.name && e.target.value ){
     this.setState({[e.target.name]: e.target.value});   
    }
  }

  changeWooPageStatusOption = (changedEvent) => {
    if (changedEvent && changedEvent.target && changedEvent.target.value) {
      this.setState({
        selectedWooPageStatusOption: changedEvent.target.value,
        selectedWooPagePuppyStatusOption: this.wooPagePuppyStatusOptions.Sold
      });
    }
    else {
      this.setState({
        selectedWooPageStatusOption: this.wooPageStatusOptions.Public,
        selectedWooPagePuppyStatusOption: this.wooPagePuppyStatusOptions.Sold
      });
    }
  };

  changeWooPagePuppyStatusOption = (changedEvent) => {
    if (changedEvent && changedEvent.target && changedEvent.target.value) {
      this.setState({
        selectedWooPagePuppyStatusOption: changedEvent.target.value,
        soldReason: null,
        currentFormNotValid: false
      });
    }
    else {
      this.setState({
        selectedWooPagePuppyStatusOption: this.wooPagePuppyStatusOptions.Available,
        currentFormNotValid: false
      });
    }
  };

  PrevStep = event => {
    this.setState({
      currentStep: this.state.currentStep - 1,
      currentStepValid: false
    });
  };

  resetState = () => {
    this.setState(initialState);
    this.props.fetchMedicalRecords();
  };

  closeModal = () => {
    $("#new_contract").modal("hide");
    this.resetState();
  };

  acceptMethods(childDownload) {
    // Parent stores the method that the child passed
    this.childDownload = childDownload;
  }

  openPdf = () => {
    this.props.updatePrintContract(this.props.contract.id);
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  applyDiscount() {
    if(parseFloat(this.state.newDiscount) <= 0){
      NotificationManager.warning("Discount should be greater than 0");
    }else if(parseFloat(this.state.price) < parseFloat(this.state.newDiscount)){
      NotificationManager.warning("Discount cannot be greater than the price");
    }else{
      this.setState({discountApplied : true, discount : parseFloat(this.state.newDiscount).toFixed(2)});
      $('#add_discount').modal('hide');
    }  
  }

  removeDiscount(event) {
    event.preventDefault();
    this.setState({discountApplied : false, discount : 0 , newDiscount : 0});
  }


  calculateAmount(total) {
    if(this.state.payments.length === 1) {
      this.setState({
        payments: [
          ...this.state.payments.slice(0, 0),
          Object.assign({}, this.state.payments[0], {
            amount: parseFloat(total).toFixed(2)
          })
        ]
      });
    }
  }

  changeStateOfSoldPopUp(){
    $("#woo_page_status_modal").modal("hide");
    $("#send_notification_model").modal("show");
  }

  setWooPageStatus = () => {
    let puppyPageStatus = this.state.selectedWooPagePuppyStatusOption ? this.state.selectedWooPagePuppyStatusOption : null;
    let soldReason = this.state.soldReason ? this.state.soldReason : null;
    if( soldReason ){
      let data = this.state.contractSubmitData;
        data.updateWooStoreData = {
          wooPageStatus : this.state.selectedWooPageStatusOption,
          wooPagePuppyStatus : this.state.selectedWooPagePuppyStatusOption,
          soldReason : this.state.soldReason,
        }  
      this.submitContract(data);
      $("#woo_page_status_modal").modal("hide");
    }else{
      NotificationManager.error("Please select the sold reason");
    }
  };

  closeConfirmModal(){
    $('#confirm_select_modal').modal('hide');   
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.contractError) {
      NotificationManager.error("Something went wrong.");
      this.resetState();
    }
    if (nextProps.mRecordsError || nextProps.hwTypesError) {
      NotificationManager.error("Something went wrong.");
    }
    if(  nextProps.pets &&  nextProps.pets.medicalRecords && nextProps.pets. medicalRecords.length > 0 && this.props.pets.medicalRecords !== nextProps.pets.medicalRecords ) {
      let options = [];
      let pets = nextProps.pets.medicalRecords;  
       pets.map(pet => {
       if(pet){
        options.push({ label: pet.pet_id, value: pet.id, wooPet : pet.woo_pet, 
          wooPageStatus : pet.woo_page_status, wooPetStatus : pet.woo_pet_availability,
          wooPetId : pet.woo_pet_id, avatar_path : pet.avatar_path,
          avatar_file_name : pet.avatar_file_name, pet_id : pet.pet_id
        });
        }

      });
      this.setState({ pets: options });
    }
    if (
      this.props.hwTypes !== nextProps.hwTypes &&
      nextProps.hwTypes.length > 0
    ) {
      let options = [{ label: "select one", value: "N/A" }];
      nextProps.hwTypes.map(f => {
        options.push({ label: f.hw_find_us_type, value: f.hw_find_us_type });
      });
      this.setState({ hwTypes: options });
      this.setState({ hwFindUS: options[0].value });
    }
    if (this.props.contract !== nextProps.contract) {
      this.resetState();
      this.nextStep();
      this.setState({ loading: false });
      NotificationManager.success("Contract created successfully");
    }
    if (this.props.newHwType !== nextProps.newHwType) {
      this.props.fetchHwFindUsTypes();
    }
    if (this.props.configs !== nextProps.configs) {
      const taxRateObj = nextProps.configs.find(
        ({ name }) => name === "default_tax_rate"
      );
      this.setState({ taxRate: taxRateObj.value });
    }
    if (this.props.paymentTypes !== nextProps.paymentTypes) {
      this.setState({ payment_types: nextProps.paymentTypes });
    }

    if(nextProps.petInfo && this.props.petInfo !== nextProps.petInfo) {
      let tax = this.calculateTotal(nextProps.petInfo.price, this.state.taxRate, 0).tax;
      let total = this.calculateTotal(nextProps.petInfo.price, this.state.taxRate, 0).total;  
      this.calculateAmount(total);
      this.setState({petInfo: nextProps.petInfo , price : nextProps.petInfo.price ? nextProps.petInfo.price : 0 , tax : tax , total : total});
    }

    if(this.props.searchedMedicalRecords !== nextProps.searchedMedicalRecords){   
      this.setState({ searchedMedicalRecords : nextProps.searchedMedicalRecords, loadingInfo : false });
    }

    if(this.props.searchedMedicalRecordsError !== nextProps.searchedMedicalRecordsError){ 
      NotificationManager.error("An error occurred while loading medical records");  
      this.setState({  loadingInfo : false });
    }

    if (this.props.subscribeToPetByMedicalRecord !== nextProps.subscribeToPetByMedicalRecord) {
      this.setState({ availableSubscribers: nextProps.subscribeToPetByMedicalRecord });
    }
  };

  componentDidMount = () => {
    this.setState({ country: this.props.petShop.currentPetshop.country, loadingInfo: true  });
    this.props.fetchMedicalRecords();
    this.props.fetchHwFindUsTypes();
    this.props.fetchConfig();
    this.props.fetchPaymentTypes();
    this.props.getRecentAvailableMedicalRecords({ petIdInput:null });
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.currentStep !== this.state.currentStep) {
      document.getElementById("progress-status").style.width =
        "calc(" + (parseInt(this.state.currentStep) + 1) * 25 + "% + 26px)";
    }
    if (this.props.printContract !== prevProps.printContract) {
      this.childDownload();
    }

    if (prevState.discount !== this.state.discount) {
      let total = this.calculateTotal(this.state.price, this.state.taxRate, this.state.discount).total;
      let new_tax = this.calculateTotal(this.state.price, this.state.taxRate, this.state.discount).tax;   
      this.calculateAmount(total);
      this.setState({tax : new_tax, total: total});
    }
  };

  confirmContract(notify){
    let data = this.state.contractSubmitData;
    data["notifySubscribers"] = notify;
    data.updateWooStoreData = {
      wooPageStatus : this.state.selectedWooPageStatusOption,
      wooPagePuppyStatus : this.state.selectedWooPagePuppyStatusOption,
      soldReason : this.state.soldReason,
    }; 
    this.submitContract(data);
    $("#send_notification_model").modal("hide");   
  }

  items = [
    { title: "Contracts", to: "/contracts" },
    { title: "New Contract", to: "/contracts/add" }
  ];

  render() {
    const {
      petIdInput,
      address_opt,
      country,
      currentStep,
      pets,
      petId,
      date,
      firstname,
      lastname,
      address,
      city,
      state,
      zip_code,
      phone_primary,
      phone_primary_type,
      phone_secondary,
      phone_secondary_type,
      email,
      hwTypes,
      hwFindUS,
      price,
      tax,
      discount,
      newDiscount,
      discountApplied,
      taxRate,
      total,
      payments,
      payment_types,
      delivery_address,
      delivery_address_opt,
      delivery_town_city,
      delivery_state,
      delivery_zip_code,

      sameAsBillingAddress,
      searchedMedicalRecords, 
      selectedMedicalRecord,
      soldReason,
      find_us_other,
    } = this.state;
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--lg m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        New Contract
                      </h3>
                    </div>
                  </div>
                </div>
                <div
                  className="m-wizard m-wizard--1 m-wizard--success"
                  id="m_wizard"
                >
                  <div className="m-wizard__head m-portlet__padding-x">
                    <div className="m-wizard__progress">
                      <div className="progress">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow="100"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          id="progress-status"
                        ></div>
                      </div>
                    </div>

                    <div className="m-wizard__nav">
                      <div className="m-wizard__steps">
                        <div
                          className={
                            "m-wizard__step " +
                            (this.state.currentStep === 0
                              ? "m-wizard__step--current"
                              : this.state.currentStep > 0 &&
                                "m-wizard__step--done")
                          }
                          m-wizard-target="m_wizard_form_step_1"
                          id={"wizard-step0"}
                        >
                          <div className="m-wizard__step-info">
                            <a href="#" className="m-wizard__step-number">
                              <span>
                                <span>1</span>
                              </span>
                            </a>
                            <div className="m-wizard__step-line">
                              <span></span>
                            </div>
                            <div className="m-wizard__step-label">
                              Pet Information
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            "m-wizard__step " +
                            (this.state.currentStep === 1
                              ? "m-wizard__step--current"
                              : this.state.currentStep > 1 &&
                                "m-wizard__step--done")
                          }
                          m-wizard-target="m_wizard_form_step_2"
                          id={"wizard-step1"}
                        >
                          <div className="m-wizard__step-info">
                            <a href="#" className="m-wizard__step-number">
                              <span>
                                <span>2</span>
                              </span>
                            </a>
                            <div className="m-wizard__step-line">
                              <span></span>
                            </div>
                            <div className="m-wizard__step-label">
                              Customer Information
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            "m-wizard__step " +
                            (this.state.currentStep === 2
                              ? "m-wizard__step--current"
                              : this.state.currentStep > 2 &&
                                "m-wizard__step--done")
                          }
                          m-wizard-target="m_wizard_form_step_3"
                          id={"wizard-step2"}
                        >
                          <div className="m-wizard__step-info">
                            <a href="#" className="m-wizard__step-number">
                              <span>
                                <span>3</span>
                              </span>
                            </a>
                            <div className="m-wizard__step-line">
                              <span></span>
                            </div>
                            <div className="m-wizard__step-label">Payment</div>
                          </div>
                        </div>
                        <div
                          className={
                            "m-wizard__step " +
                            (this.state.currentStep === 3
                              ? "m-wizard__step--current"
                              : this.state.currentStep > 3 &&
                                "m-wizard__step--done")
                          }
                          m-wizard-target="m_wizard_form_step_4"
                          id={"wizard-step3"}
                        >
                          <div className="m-wizard__step-info">
                            <a href="#" className="m-wizard__step-number">
                              <span>
                                <span>4</span>
                              </span>
                            </a>
                            <div className="m-wizard__step-line">
                              <span></span>
                            </div>
                            <div className="m-wizard__step-label">Print</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="m-wizard__form">
                    <form
                      id="step_0"
                      onSubmit={this.validateForm}
                      className="m-form m-form--label-align-left- m-form--state-"
                    >
                      <div className="m-portlet__body m-portlet__body_grey">
                        {currentStep === 0 && (
                          <div id={"form-step0"}>
                            <div className="row">
                              <div className="col-xl-8 offset-xl-2 col-md-8 offset-md-2">
                                <div className="m-form__section m-form__section--first">
                                  <div className="col-xl-12">
                                    <div className="form-group m-form__group row">
                                      <label className="col-lg-3 col-form-label">
                                        Pet Id:
                                      </label>
                                      <div className="col-lg-6">
                                        <input
                                          type="text"
                                          onChange={evt => this.findPet(evt)}
                                          placeholder="Enter Pet ID "
                                          className="form-control m-input"
                                          value={petIdInput}
                                        />
                                        {/* <Select options={pets} value={petId} name="petId" onChange={this.changePet} placeholder="Select the pet" /> */}
                                        {/* <span
                                          className={
                                            form_step_0.petId === null &&
                                            this.state.currentStepNotValid
                                              ? "m-form__help_danger"
                                              : "display-none"
                                          }
                                        >
                                          Select the pet
                                        </span> */}
                                      </div>
                                      <div className="col-lg-2">
                                        <a 
                                          href="#"
                                          data-toggle="modal"
                                          data-target="#recent-medical-record-modal"
                                          className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                        >                                
                                          <i className="far fa-eye"></i>
                                        
                                        </a>
                                      </div>
                                    </div>
                                    {petId && (
                                      <div className="mt-2">
                                        <PetInfo petId={this.state.petId} />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {currentStep === 1 && (
                          <div id={"form-step1"}>
                            <div className="row">
                              <div className="col-xl-8 offset-xl-2 col-md-8 offset-md-2">
                                <div className="m-form__section m-form__section--first">
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Date:
                                    </label>
                                    <div className="col-lg-8">
                                      <DatePicker
                                        selected={date}
                                        onChange={this.changeDate}
                                        onSelect={this.changeDate}
                                      />
                                      <span
                                        className={
                                          form_step_1.date === null &&
                                          this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        Select the date
                                      </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">
                                      {" "}
                                      First Name:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="firstname"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={firstname}
                                      />
                                      <span
                                        className={
                                          form_step_1.firstname === null &&
                                          this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        Enter the customer first name
                                      </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4">
                                      {" "}
                                      Last Name:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="lastname"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={lastname}
                                      />
                                      <span
                                        className={
                                          form_step_1.lastname === null &&
                                          this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        Enter the customer last name
                                      </span>
                                    </div>
                                  </div>

                                  <div className="mr-auto">
                                      <h5 className="m-subheader__title m--font-brand">Billing Information</h5>			
                                  </div>   
                                  
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Street Address:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="address"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={address}
                                      />
                                      <span
                                        className={
                                          form_step_1.saddress === null &&
                                          this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        Enter the customer address
                                      </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Apt/Suite/Building:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="address_opt"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={address_opt}
                                      />
                                      <span className="m-form__help">
                                        Enter additional address
                                        details(Optional)
                                      </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      City:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="city"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={city}
                                      />
                                      <span
                                        className={
                                          form_step_1.city === null &&
                                          this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        Enter the customer city
                                      </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      State:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="state"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={state}
                                      />
                                      <span
                                        className={
                                          form_step_1.state === null &&
                                          this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        Enter the customer state
                                      </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Zip Code:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="zip_code"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={zip_code}
                                      />
                                      <span
                                        className={
                                          form_step_1.zip === null &&
                                          this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        Enter the customer zip code
                                      </span>
                                    </div>
                                  </div>

                                  <div className="mr-auto">
                                      <h5 className="m-subheader__title m--font-brand">Delivery Information</h5>			
                                  </div>

                                  <label className="my-3">
                                    <input name="sameAsBillingAddress" type="checkbox" checked={sameAsBillingAddress} onChange={this.handleInputChange} />
                                    <span className="ml-1">Same As Billing Address</span>
                                  </label>

                                  {!sameAsBillingAddress ?

                                  <div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Street Address:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="delivery_address"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={delivery_address}
                                      />
                                    </div>
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                    Apartment, Suite, Unit, Etc.:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="delivery_address_opt"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={delivery_address_opt}
                                      />
                                    </div>
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                    Town / City:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="delivery_town_city"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={delivery_town_city}
                                      />
                                    </div>
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                    State:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="delivery_state"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={delivery_state}
                                      />
                                    </div>
                                  </div>

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                    Zip Code:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="text"
                                        name="delivery_zip_code"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={delivery_zip_code}
                                      />
                                    </div>
                                  </div>

                                  </div>

                                  : ""}

                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Primary Phone:
                                    </label>
                                    <div className="col-lg-8">
                                      <div className="input-group mb-2">
                                        <div className="input-group-prepend">
                                          <select
                                            type="text"
                                            name="phone_primary_type"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                            placeholder=""
                                            value={phone_primary_type}
                                          >
                                            <option>mobile</option>
                                            <option>work</option>
                                            <option>home</option>
                                          </select>
                                        </div>
                                        <PhoneInput
                                          country={country}
                                          className="form-control"
                                          placeholder="Enter primary number"
                                          value={phone_primary}
                                          onChange={value =>
                                            this.setState({
                                              phone_primary: value
                                            })
                                          }
                                        />
                                        {/* <input type="text" name="phone_cell" onChange={this.changeVal} className="form-control m-input" placeholder="" value={phone_cell}/> */}
                                      </div>
                                      <span
                                        className={
                                          form_step_1.phone_primary === null &&
                                          this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        Enter the primary phone number
                                      </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Secondary Phone:
                                    </label>
                                    <div className="col-lg-8">
                                      <div className="input-group mb-2">
                                        <div className="input-group-prepend">
                                          <select
                                            type="text"
                                            name="phone_secondary_type"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                            placeholder=""
                                            value={phone_secondary_type}
                                          >
                                            <option>mobile</option>
                                            <option>work</option>
                                            <option>home</option>
                                          </select>
                                        </div>
                                        <PhoneInput
                                          country={country}
                                          className="form-control"
                                          placeholder="Enter primary number"
                                          value={phone_secondary}
                                          onChange={value =>
                                            this.setState({
                                              phone_secondary: value
                                            })
                                          }
                                        />
                                        {/* <input type="text" name="phone_home" onChange={this.changeVal} className="form-control m-input" placeholder="" value={phone_home}/> */}
                                      </div>
                                      <span
                                        className={
                                          form_step_1.phone_secondary ===
                                            null &&
                                          this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        Enter the secondary phone number
                                      </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      Email:
                                    </label>
                                    <div className="col-lg-8">
                                      <input
                                        type="email"
                                        name="email"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder=""
                                        value={email}
                                      />
                                      <span
                                        className={
                                          form_step_1.email === null &&
                                          this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        {" "}
                                        Enter the customer email{" "}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                                      How did you find us:
                                    </label>
                                    <div className="col-lg-6">
                                      <Select
                                        options={hwTypes}
                                        value={hwFindUS}
                                        name="hwFindUS"
                                        onChange={this.changeHwType}
                                        placeholder="Select how you find us?"
                                      />
                                      {/* <select type="text" name="find_us" onChange={this.changeVal} className="form-control m-input" placeholder="" value={find_us}>
                                      <option>Drive By</option>
                                      <option>Google</option>
                                      <option>Refferals</option>
                                      </select> */}
                                      <span
                                        className={
                                          form_step_1.isInValidHFindus &&
                                          this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        {" "}
                                        Tell us how you found us{" "}
                                      </span>
                                    </div>
                                    <div className="col-lg-2">
                                      <a
                                        href="#"
                                        data-toggle="modal"
                                        data-target="#add_hwf_type"
                                        className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                      >
                                        <i className="la la-plus"></i>
                                      </a>
                                    </div>
                                  </div>
                                  { this.state.isFindUsOtherEnable &&
                                   <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">
                               
                                    </label>
                                    <div className="col-lg-8">
                                    <input
                                        type="text"
                                        name="find_us_other"
                                        onChange={this.changeVal}
                                        className="form-control m-input"
                                        placeholder="Type how you found us"
                                        value={find_us_other}
                                      />                            
                                      <span
                                        className={
                                          form_step_1.isInValidFindUsOther &&
                                          this.state.currentStepNotValid
                                            ? "m-form__help_danger"
                                            : "display-none"
                                        }
                                      >
                                        {" "}
                                        Type how you found us{" "}
                                      </span>
                                    </div>                            
                                  </div>
                                 }
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {currentStep === 2 && (
                          <div id={"form-step2"}>
                            <div className="row">
                              <div className="col-xl-8 offset-xl-2 col-md-8 offset-md-2">
                                <div className="m-form__section m-form__section--first">
                                  <div className="col-xl-12">
                                    {discountApplied ? (
                                      <>
                                        <div className="row">
                                          <div className="col-xs-12">
                                            <div className="m-form__section m-form__section--first row">
                                              <div
                                                className="form-group m-form__group col-md-3"
                                                  style={{ paddingTop: "15px" }}
                                              >
                                              <label htmlFor="example_input_full_name">
                                                Price:
                                              </label>
                                              <div className="input-group m-input-group">
                                                <div className="input-group-prepend">
                                                  <span className="input-group-text">
                                                    $
                                                  </span>
                                                </div>                                          
                                                <span className="input-group-text">
                                                  {parseFloat(price).toFixed(2)}
                                                </span>                                      
                                              </div>
                                              <span
                                                className={
                                                  form_step_2.price === null &&
                                                  this.state.currentStepNotValid
                                                    ? "m-form__help_danger"
                                                    : "display-none"
                                                }
                                              >
                                                Enter the price
                                              </span>
                                            </div>                                        
                                          <div
                                            className="col-md-1"
                                            style={{
                                              display: "flex",
                                              alignItems: "center"
                                            }}
                                          >
                                            -
                                          </div>
                                          <div className="form-group m-form__group col-md-3">
                                            <label htmlFor="example_input_full_name">
                                              Discount:
                                            </label>
                                            <div className="input-group m-input-group">
                                              <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                  $
                                                </span>
                                              </div>{" "}
                                              <input
                                                style={{width : "80px !important"}}
                                                name="discount"
                                                value={discount}
                                                onChange={this.changeVal}
                                                className="form-control m-input"
                                                // placeholder=""
                                                aria-describedby="basic-addon1"
                                              /> 
                                            </div>
                                          </div>
                                          <div
                                            className="col-md-1"
                                            style={{
                                              display: "flex",
                                              alignItems: "center"
                                            }}
                                          >
                                            +
                                          </div>
                                          <div className="form-group m-form__group col-md-3">
                                            <label htmlFor="example_input_full_name">
                                              Tax:
                                            </label>
                                            <div className="input-group m-input-group">
                                              <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                  $
                                                </span>
                                              </div>
                                              <span className="input-group-text" style={{width : "80px"}}>
                                                {tax > 0 ? parseFloat(tax).toFixed(2) : "0"}
                                              </span>                                            
                                            </div>
                                            <span className="m-form__help">
                                              tax rate {taxRate}%
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mb-4">
                                      <div className="m-form  form-group m-form__group col-md-8">
                                        </div>
                                      <div
                                        className="col-md-1"
                                        style={{ display: "flex", alignItems: "center" }}
                                      >
                                        =
                                      </div>
                                      <div className="m-form  form-group m-form__group col-md-3">
                                        <span className="m-widget4__sub">
                                          <span>
                                            <strong>Total: </strong>
                                          </span>
                                        </span>
                                        <div className="input-group m-input-group">
                                          <div className="input-group-prepend">
                                            <span className="input-group-text">$</span>
                                            <span className="input-group-text" style={{width : "80px"}}>                                          
                                               {total > 0 ? parseFloat(total).toFixed(2) : "0"}
                                            </span>
                                          </div>                                   
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ): (
                                  <div className="row">
                                    <div className="col-xs-12">
                                      <div className="m-form__section m-form__section--first row">
                                        <div
                                          className="form-group m-form__group col-md-3"
                                          style={{ paddingTop: "15px" }}
                                        >
                                          <label htmlFor="example_input_full_name">
                                            Price:
                                          </label>
                                          <div className="input-group m-input-group">
                                            <div className="input-group-prepend">
                                              <span className="input-group-text">
                                                $
                                              </span>
                                            </div>
                                            <span className="input-group-text">
                                              {parseFloat(price).toFixed(2)}
                                            </span>  
                                          </div>
                                          <span
                                            className={
                                              form_step_2.price === null &&
                                              this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            Enter the price
                                          </span>
                                        </div>
                                        <div
                                          className="col-md-1"
                                          style={{
                                            display: "flex",
                                            alignItems: "center"
                                          }}
                                        >                                        
                                        +
                                      </div>
                                      <div className="form-group m-form__group col-md-3">
                                        <label htmlFor="example_input_full_name">
                                          Tax:
                                        </label>
                                        <div className="input-group m-input-group">
                                          <div className="input-group-prepend">
                                            <span className="input-group-text">
                                              $
                                            </span>
                                          </div>{" "}
                                          <span className="input-group-text">
                                            {tax > 0 ? tax : "0"}
                                          </span>                                        
                                        </div>
                                        <span className="m-form__help">
                                          tax rate {taxRate}%
                                        </span>
                                      </div>
                                      <div
                                        className="col-md-1"
                                        style={{
                                          display: "flex",
                                          alignItems: "center"
                                        }}
                                      >
                                        =
                                      </div>
                                      <div className="form-group m-form__group col-md-4">
                                        <label htmlFor="example_input_full_name">
                                          Total:
                                        </label>
                                        <div className="input-group m-input-group">
                                          <div className="input-group-prepend">
                                            <span className="input-group-text">
                                              $
                                            </span>
                                          </div>
                                          <span className="input-group-text">
                                            {total > 0 ? total : "0"}
                                          </span>
                                          
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>         
                                )}                                   
                                {
                                  discountApplied > 0 ? (
                                    <div className="row mb-4">
                                      <a 
                                        className="ml-4"
                                        href="#"                                          
                                        onClick={(e) => this.removeDiscount(e)}
                                      >
                                        Remove Discount
                                      </a>
                                      </div>
                                    ) :(
                                        <div className="row mb-4">
                                        <a 
                                          className="ml-4"
                                          href="#"
                                          data-toggle="modal"
                                          data-target="#add_discount"
                                        >
                                          Add Discount
                                        </a>
                                      </div>
                                    )
                                }

                                    <div className="row">
                                      <div
                                        className="col-xs-12"
                                        style={{ width: "100%" }}
                                      >
                                        <div className="m-form__section m-form__section--first row mb-2">
                                          <div
                                            className="m-accordion m-accordion--default"
                                            id="m_accordion_4"
                                            role="tablist"
                                            style={{ width: "100%" }}
                                          >
                                            {payments.length > 0 &&
                                              payments.map((p, i) => (
                                                <div
                                                  className="m-accordion__item"
                                                  key={i}
                                                >
                                                  <div
                                                    className="m-accordion__item-head collapsed"
                                                    role="tab"
                                                    id={
                                                      "m_accordion_4_item_" +
                                                      i +
                                                      "_head"
                                                    }
                                                    data-toggle="collapse"
                                                    href={
                                                      "#m_accordion_4_item_" +
                                                      i +
                                                      "_body"
                                                    }
                                                    aria-expanded="false"
                                                  >
                                                    <span className="m-accordion__item-icon">
                                                      <i className="la la-money"></i>
                                                    </span>
                                                    <span className="m-accordion__item-title">
                                                      Payment {i + 1}
                                                    </span>
                                                    <span className="m-accordion__item-mode"></span>
                                                  </div>
                                                  <div
                                                    className="m-accordion__item-body collapse"
                                                    id={
                                                      "m_accordion_4_item_" +
                                                      i +
                                                      "_body"
                                                    }
                                                    role="tabpanel"
                                                    aria-labelledby={
                                                      "m_accordion_4_item_" +
                                                      i +
                                                      "_head"
                                                    }
                                                    data-parent="#m_accordion_4"
                                                  >
                                                    <div className="m-accordion__item-content">
                                                      <div className="form-group m-form__group row">
                                                        <label className="col-lg-4 col-form-label">
                                                          Payment Method
                                                        </label>
                                                        <div className="col-lg-8">
                                                          <select
                                                            type="text"
                                                            name="method"
                                                            onChange={e => {
                                                              this.changePayment(
                                                                e,
                                                                i
                                                              );
                                                            }}
                                                            className="form-control m-input"
                                                            placeholder=""
                                                            value={p.method}
                                                          >
                                                            <option value="other">
                                                              Other
                                                            </option>
                                                            <option value="credit_debit">
                                                              Credit/Debit
                                                            </option>
                                                          </select>
                                                        </div>
                                                      </div>
                                                      {p.method === "other" && (
                                                        <div>
                                                          <div className="form-group m-form__group row">
                                                            <label className="col-lg-4 col-form-label">
                                                              Type
                                                            </label>
                                                            <div className="col-lg-8">
                                                              <select
                                                                type="text"
                                                                name="other_type"
                                                                onChange={e => {
                                                                  this.changePayment(
                                                                    e,
                                                                    i
                                                                  );
                                                                }}
                                                                className="form-control m-input"
                                                                value={
                                                                  p.other_type
                                                                }
                                                              >
                                                                <option>
                                                                  {" "}
                                                                  none{" "}
                                                                </option>
                                                                {payment_types.map(
                                                                  (
                                                                    type,
                                                                    index
                                                                  ) => (
                                                                    <option
                                                                      value={
                                                                        type.id
                                                                      }
                                                                      key={
                                                                        index
                                                                      }
                                                                    >
                                                                      {
                                                                        type.payment_type
                                                                      }
                                                                    </option>
                                                                  )
                                                                )}
                                                              </select>
                                                              <span
                                                                className={
                                                                  form_step_2
                                                                    .payments[i]
                                                                    .other_type ===
                                                                    null &&
                                                                  this.state
                                                                    .currentStepNotValid
                                                                    ? "m-form__help_danger"
                                                                    : "display-none"
                                                                }
                                                              >
                                                                Select Type
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      )}
                                                      <div className="form-group m-form__group row">
                                                        {p.method ===
                                                          "other" && (
                                                          <label className="col-lg-4 col-form-label">
                                                            {/* {
                                                              payment_types.find(
                                                                ({ id }) =>
                                                                  id ===
                                                                  p.other_type
                                                              ).payment_type
                                                            }{" "} */}
                                                            Amount
                                                          </label>
                                                        )}
                                                        {p.method ===
                                                          "credit_debit" && (
                                                          <label className="col-lg-4 col-form-label">
                                                            Credit/Debit Amount
                                                          </label>
                                                        )}
                                                        {/* {p.method ===
                                                          "community_finance" && (
                                                          <label className="col-lg-4 col-form-label">
                                                            Community Amount
                                                          </label>
                                                        )} */}
                                                        <div className="col-lg-8">
                                                          <input
                                                            type="text"
                                                            name="amount"
                                                            onChange={e => {
                                                              this.changePayment(
                                                                e,
                                                                i
                                                              );
                                                            }}
                                                            className="form-control m-input"
                                                            placeholder="0"
                                                            value={
                                                              p.amount > 0
                                                                ? p.amount
                                                                : ""
                                                            }
                                                          />
                                                          <span
                                                            className={
                                                              form_step_2
                                                                .payments[i]
                                                                .amount ===
                                                                null &&
                                                              this.state
                                                                .currentStepNotValid
                                                                ? "m-form__help_danger"
                                                                : "display-none"
                                                            }
                                                          >
                                                            Enter the amount
                                                          </span>
                                                        </div>
                                                      </div>

                                                      {p.method ===
                                                        "credit_debit" && (
                                                        <div>
                                                          <div className="form-group m-form__group row">
                                                            <label className="col-lg-4 col-form-label">
                                                              Card Type
                                                            </label>
                                                            <div className="col-lg-8">
                                                              <select
                                                                type="text"
                                                                name="card_type"
                                                                onChange={e => {
                                                                  this.changePayment(
                                                                    e,
                                                                    i
                                                                  );
                                                                }}
                                                                className="form-control m-input"
                                                                placeholder=""
                                                                value={
                                                                  p.card_type
                                                                }
                                                              >
                                                                <option>
                                                                  {" "}
                                                                  none{" "}
                                                                </option>
                                                                <option value="visa">
                                                                  Visa
                                                                </option>
                                                                <option value="master">
                                                                  Master
                                                                </option>
                                                                <option value="paywave">
                                                                  PayWave
                                                                </option>
                                                              </select>
                                                              <span
                                                                className={
                                                                  form_step_2
                                                                    .payments[i]
                                                                    .card_type ===
                                                                    null &&
                                                                  this.state
                                                                    .currentStepNotValid
                                                                    ? "m-form__help_danger"
                                                                    : "display-none"
                                                                }
                                                              >
                                                                Select card type
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className="form-group m-form__group row">
                                                            <label className="col-lg-4 col-form-label">
                                                              Last 4 Digits
                                                            </label>
                                                            <div className="col-lg-8">
                                                              <input
                                                                type="number"
                                                                name="last_digits"
                                                                onChange={e => {
                                                                  this.changePayment(
                                                                    e,
                                                                    i
                                                                  );
                                                                }}
                                                                className="form-control m-input"
                                                                placeholder=""
                                                                value={
                                                                  p.last_digits
                                                                }
                                                              />
                                                              <span
                                                                className={
                                                                  form_step_2
                                                                    .payments[i]
                                                                    .last_digits ===
                                                                    null &&
                                                                  this.state
                                                                    .currentStepNotValid
                                                                    ? "m-form__help_danger"
                                                                    : "display-none"
                                                                }
                                                              >
                                                                Enter the last 4
                                                                digits of card
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      )}
                                                      <div className="m-widget4__item m--align-right">
                                                        <span className="m-widget4__sub">
                                                          <a
                                                            href="#"
                                                            onClick={event =>
                                                              this.removePayment(
                                                                event,
                                                                i
                                                              )
                                                            }
                                                            className="btn m-btn--pill btn-outline-danger btn-sm mx-2"
                                                          >
                                                            <span>
                                                              <i className="la la-minus-circle mr-2"></i>
                                                              <span>
                                                                Delete
                                                              </span>
                                                            </span>
                                                          </a>
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ))}
                                          </div>
                                        </div>
                                        <div
                                          className="m-form__section row mt-2"
                                          style={{ float: "right" }}
                                        >
                                          <a
                                            href="#"
                                            onClick={event =>
                                              this.newPayment(event)
                                            }
                                            className="btn btn-outline-primary m-btn m-btn--icon m-btn--pill"
                                          >
                                            <span>
                                              <i className="la la-plus"></i>
                                              <span>New Payment</span>
                                            </span>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {currentStep === 3 && (
                          <div id={"form-step3"}>
                            <div className="row">
                              <div className="col-xl-8 offset-xl-2 col-md-8 offset-md-2">
                                <div className="m-form__section m-form__section--first">
                                  <div className="col-xl-12">
                                    <div className="m-form__section m-form__section--first">
                                      <h3 className="m--font-success mb-2">
                                        Contract created Successfully.
                                      </h3>
                                      <br />
                                      <h6>
                                        How do you wish to continue with the
                                        contract?
                                      </h6>
                                    </div>
                                    <div
                                      className="m-form__section my-3 row"
                                      style={{ textALign: "center" }}
                                    >
                                      <NavLink
                                        to={`/contracts/${this.props.contract.id}`}
                                        className="btn btn-outline-primary m-btn m-btn--icon m-btn--pill mr-2"
                                      >
                                        <span>
                                          <i className="la la-desktop"></i>
                                          <span>Edit</span>
                                        </span>
                                      </NavLink>
                                      <a
                                        href="#"
                                        onClick={() => this.openPdf()}
                                        className="btn btn-primary m-btn m-btn--icon m-btn--pill"
                                      >
                                        <span>
                                          <i className="la la-print"></i>
                                          <span>Print</span>
                                        </span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {currentStep !== 3 && (
                          <div className="m-portlet__foot">
                            <div className="row align-items-center">
                              <div className="col-lg-12 m--align-right">
                                {this.state.loading == false ? (
                                  <div>
                                    {currentStep !== 0 && (
                                      <button
                                        type="button"
                                        onClick={this.PrevStep}
                                        className="btn btn-secondary m-btn--pill mx-2"
                                      >
                                        <span>
                                          <i className="la la-arrow-left"></i>
                                          &nbsp;&nbsp;
                                          <span>Back</span>
                                        </span>
                                      </button>
                                    )}
                                    {currentStep === 2 ? (
                                      <button
                                        type="button"
                                        onClick={this.validateStep}
                                        className="btn btn-primary m-btn--pill"
                                      >
                                        <span>
                                          <i className="la la-check"></i>
                                          &nbsp;&nbsp;
                                          <span>Submit</span>
                                        </span>
                                      </button>
                                    ) : (
                                      currentStep !== 3 && (
                                        <button
                                          type="button"
                                          onClick={this.validateStep}
                                          className="btn btn-primary m-btn--pill"
                                        >
                                          <span>
                                            <span>Save & Continue</span>
                                            &nbsp;&nbsp;
                                            <i className="la la-arrow-right"></i>
                                          </span>
                                        </button>
                                      )
                                    )}
                                  </div>
                                ) : (
                                  <div className="center-row">
                                    <Loader size={50} />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ContractPDF setClick={this.acceptMethods.bind(this)} />
        <AddHwFindUs />
        <div
          className="modal fade"
          id="add_discount"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Add Discount
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group m-form__group row">                
                   <label className="col-lg-4 pt-1 mt-1">
                     {" "}
                     Discount :
                   </label>
                   <div className="col-lg-8">
                   <div className="input-group m-input-group">
                     <div className="input-group-prepend">
                        <span className="input-group-text">
                          $
                        </span>
                        <input
                          name="newDiscount"
                          value={newDiscount}
                          onChange={this.changeVal}
                          className="form-control m-input"
                          placeholder=""
                          aria-describedby="basic-addon1"
                        />
                      </div>                                       
                      </div>
                    </div>
                 </div>
                </div>
                <div className="modal-footer">
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => this.applyDiscount()}
                      className="btn btn-primary m-btn--pill"
                    >
                      Confirm
                    </button>
                  </div>
                </div>
            </div>
          </div>
        </div>    

        <div
          className="modal fade"
          id="send_notification_model"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Confirm to send notifications
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                Do you want to notify subscribers of these changes?
                </p>
              </div>
              <div className="modal-footer">
                {this.state.loadingStore == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      onClick={() => this.confirmContract(false)}
                    >
                      No
                    </button>
                    <button
                      type="button"
                      onClick={() => this.confirmContract(true)}
                      className="btn btn-primary m-btn--pill"
                    >
                      Yes
                    </button>
                  </div>
                ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div> 

        <div className="modal fade show" id="recent-medical-record-modal" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content modal-scrollable-dialog">         
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Recent Medical Records</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body modal-scrollable-body">                    
                      <div className="row">
                        <div className="col-xl-12">
                          {this.state.loadingInfo === false ?
                            <ToolkitProvider 
                            keyField="id"
                            data={searchedMedicalRecords}                      
                            columns={this.tableHecaderColumnData}
                            search
                            defaultSortDirection="asc" 
                            hover={true} 
                            filter={ filterFactory() } 
                          >
                            {
                              props => (
                                <div>
                                  <div className='px-0 mb-4 search-bar'>
                                    <div className='col-lg-3 px-0 inner-addon right-addon'>
                                    <i className="fas fa-search"></i>
                                    <SearchBar {...props.searchProps} />
                                    </div>
                                  </div>
                                  <BootstrapTable
                                    classes="petTable"
                                    {...props.baseProps}
                                    pagination={ paginationFactory() } 
                                    hover
                                    rowEvents={this.rowEvents}    
                                    rowClasses = {"contract-recent-medicalrecord-search-hover-row"}                           
                                  />
                                </div>
                              )
                            }
                            </ToolkitProvider>:  
                            <div className="center-row">
                              <Loader size={50} />
                             </div>

                           }
                        </div>
                      </div>
                  </div>
                  <div className="modal-footer">
                    {this.state.loading == false ?
                      <div>
                        <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Close</button>
                        <button type="submit" className="btn btn-primary m-btn--pill">Submit</button>
                      </div>
                      :
                      <div className="center-row">
                        <Loader size={50} />
                      </div>
                    }
                  </div>          
            </div>
          </div>
        </div>   
        <div className="modal fade show" id="confirm_select_modal" tabIndex="-1" role="dialog">
           <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Confirm the puppy</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to select this puppy(<strong>{ selectedMedicalRecord && selectedMedicalRecord.pet_id }</strong>)?</p> 
                        </div>
                        <div className="modal-footer">              
                            <div>
                                <button type="button" onClick={() => this.closeConfirmModal()} className="btn btn-secondary m-btn--pill mx-2">Cancel</button>
                                <button type="button" onClick={() => this.setMedicalRecord()} className="btn btn-primary m-btn--pill">Confirm</button>
                            </div>                   
                        </div>
                    </div>
           </div>
        </div>
        <div
          className="modal fade"
          id="woo_page_status_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Pet Status
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>        
              <div className="modal-body">
                <p>Please set the status of the pet</p>

                <div className="row"> 
                <div className="col-4 right_seperator">
                    <div className="row">
                        <div className="m-widget4__img m-widget4__img--pic mx-auto my-0">							 
                            <img src={process.env.REACT_APP_S3_PATH + '/' + selectedMedicalRecord.avatar_path + '/' + selectedMedicalRecord.avatar_file_name} alt=""/>   
                        </div>
                    </div>
                    <div className="row">
                        <div className="m-widget4__info mx-auto my-0 mt-2">
                            <span className="m-widget4__title">
                                {selectedMedicalRecord.pet_id}
                            </span>
                        </div>
                    </div>
                  </div>
                            
                  <div className="col-8">
                    <div className="my-3">
                      <input
                        type="radio"
                        id="privateWooPageStatus"
                        name="privateWooPageStatus"
                        value={this.wooPageStatusOptions.Private}
                        onChange={this.changeWooPageStatusOption}
                        checked={this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Private}
                      />
                      <label for="privateWooPageStatus" className="ml-2 mb-0">
                        Hidden
                      </label>
                      {  this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Private ?  (
                        <div className="m-radio-inline">                  
                          <label class="m-radio mb-0 ml-3 mt-2">
                            <input
                              type="radio"
                              name="petAvailability"
                              checked={this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold}
                              onChange={this.changeWooPagePuppyStatusOption}
                              value={this.wooPagePuppyStatusOptions.Sold}
                            />{" "}
                            Sold
                            <span></span>
                          </label>
                          {this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold ? 
                           <>
                          <select className="form-select" onChange={this.handleChange} name="soldReason" value={soldReason}>
                            <option hidden value={null} style={{display: "none"}}>Select Reason</option>
                            {soldReasonValues.map( row => {  
                              return <option value={row.key} key={row.id} selected={soldReason === row.key ? true : false}>{row.value}</option>
                            })
                            }
                          </select>
                          <span className="invalid-feedback" style={{display: this.state.customFormNotValid ? "block": "none"}}>Please select reason.</span>
                          </>
                        :
                        ""
                      }
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="my-3">
                      <input
                        type="radio"
                        id="publicWooPageStatus"
                        name="publicWooPageStatus"
                        value={this.wooPageStatusOptions.Public}
                        onChange={this.changeWooPageStatusOption}
                        checked={this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Public}
                      />
                      <label for="publicWooPageStatus" className="ml-2 mb-0">
                        Visible
                      </label>
                      {this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Public ? (
                        <div className="m-radio-inline">           
                          <label class="m-radio mb-0 ml-3 mt-2">
                            <input
                              type="radio"
                              name="petAvailability"
                              checked={this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold}
                              onChange={this.changeWooPagePuppyStatusOption}
                              value={this.wooPagePuppyStatusOptions.Sold}
                            />{" "}
                            Sold
                            <span></span>
                          </label>
                          {this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold ? 
                          <>
                          <select className="form-select" onChange={this.handleChange} name="soldReason" value={soldReason}>
                            <option hidden value={null} style={{display: "none"}}>Select Reason</option>
                            {soldReasonValues.map( row => {
                              return <option value={row.key} key={row.id} selected={soldReason === row.key ? true : false}>{row.value}</option>
                            })
                            }
                          </select>
                          <span className="invalid-feedback" style={{display: this.state.customFormNotValid ? "block": "none"}}>Please select reason.</span>
                         </>
                        :
                        ""
                      }
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {this.state.loadingWooPageStatus == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                    {soldReason && soldReasonValues.find(record => (record.key === soldReason && record.notify === true) && this.state.availableSubscribers && this.state.availableSubscribers.length > 0 ) ? 
                      <button
                        type="button"
                        onClick={() => this.changeStateOfSoldPopUp()}
                        className="btn btn-primary m-btn--pill"
                        >
                        Update
                      </button>
                      :
                      <button
                        type="button"
                        onClick={() => this.setWooPageStatus()}
                        className="btn btn-primary m-btn--pill"
                        >
                        Update
                      </button>
                    }
                    
                  </div>
                ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>  

      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
  petShop: state.petShopReducer,
  pets: state.medicalRecordsReducer.mRecords,
  petInfo: state.medicalRecordsReducer.showRecord,
  hwTypes: state.howFindUsReducer.hwTypes,
  newHwType: state.howFindUsReducer.newHwType,
  contract: state.contractsReducer.contract,
  printContract: state.contractsReducer.printContract,
  contractError: state.contractsReducer.contractError,
  mRecordsError: state.contractsReducer.mRecordsError,
  newHwTypeError: state.contractsReducer.newHwTypeError,
  newhwTypesError: state.contractsReducer.newhwTypesError,
  configs: state.configReducer.configs,
  paymentTypes: state.paymentTypeReducer.paymentTypes,
  searchedMedicalRecords: state.contractsReducer.searchedMedicalRecords,
  searchedMedicalRecordsError: state.contractsReducer.searchedMedicalRecordsError,
  subscribeToPetByMedicalRecord : state.subscribeToPetReducer.subscribeToPetByMr,
});

const mapDispatchToProps = dispatch => ({
  addHwFindUs: data => {
    dispatch(addHwFindUs(data));
  },
  // fetchLeftMedicalRecords: () => {
  //   dispatch(fetchLeftMedicalRecords());
  // },
  fetchMedicalRecords: () => {
    dispatch(fetchMedicalRecords());
  },
  fetchHwFindUsTypes: () => {
    dispatch(fetchHwFindUs());
  },
  createContract: attrs => {
    dispatch(addContract(attrs));
  },
  stopBackgroundScroll: () => {
    dispatch(stopBackgroundScroll());
  },
  updatePrintContract: id => {
    dispatch(updatePrintContract(id));
  },
  fetchConfig: () => {
    dispatch(fetchConfig());
  },
  fetchPaymentTypes: () => {
    dispatch(fetchPaymentType());
  },  
  getRecentAvailableMedicalRecords: (data)=>{
    dispatch(getRecentAvailableMedicalRecords(data));
  },
  getNotificationsByMedicalRecord: id => {
    dispatch(getNotificationsByMedicalRecord(id));
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Datamodal)
);
